import { SelectFields } from '@repo/toolkit/types'
import { PaginationResponse } from '@repo/ui/data-table'

import { EnrollmentSibling } from '../../lib/types/models/enrollment-siblings/enrollment-siblings'
import { FieldsSelector } from '../../lib/types/utils'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getEnrollmentSiblings<T extends FieldsSelector<EnrollmentSibling>>(
  enrollmentId: number,
  fields: T
) {
  return restApiClient
    .url(
      encodeNestedObject(
        constructApiUrl(API.enrollments.getEnrollmentSiblings.url, {
          id: enrollmentId
        }),
        { fields }
      )
    )
    .get<PaginationResponse<SelectFields<EnrollmentSibling, T>>>()
}
